/* Lane Linen — footer newsletter -> Klaviyo.
   Submits the email straight into a Klaviyo list via Klaviyo's public
   client-subscription API (no server, no API key — uses the public company ID).
   List + company are set as data attributes on the form (theme settings). */
(function () {
  "use strict";

  /* i18n: window.LL_T (snippets/ll-js-i18n.liquid) maps English UI text to the
     current language; English is the fallback. */
  var LLT = window.LL_T || {};
  function llT(s, n) { var t = LLT[s] || s; return n != null ? t.replace("{n}", n) : t; }
  if (window.__llNewsInit) return;
  window.__llNewsInit = true;

  document.addEventListener("submit", function (e) {
    var form = e.target && e.target.closest ? e.target.closest("[data-ll-klaviyo]") : null;
    if (!form) return;
    e.preventDefault();

    var company = form.getAttribute("data-company");
    var listId = form.getAttribute("data-list");
    var successMsg = form.getAttribute("data-success") || llT("Thanks for subscribing.");
    var input = form.querySelector('input[type="email"]');
    var note = form.querySelector("[data-ll-news-note]");
    var btn = form.querySelector('button[type="submit"]');
    var email = input && input.value.trim();

    function say(msg) { if (note) { note.textContent = msg; note.style.display = "block"; } }

    if (!email || !input.checkValidity()) { say(llT("Please enter a valid email.")); return; }
    if (!company || !listId) { say("Newsletter isn't configured yet."); return; }

    if (btn) { btn.disabled = true; }
    var original = btn ? btn.textContent : "";
    if (btn) btn.textContent = "…";

    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Footer newsletter",
          profile: { data: { type: "profile", attributes: { email: email } } }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    };

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company), {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2024-10-15" },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (r.status === 202 || r.ok) { say(successMsg); form.reset(); }
        else { throw new Error("HTTP " + r.status); }
      })
      .catch(function () { say(llT("Something went wrong — please try again.")); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }, true);
})();
